import { useMount } from "@/hooks/useMount";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToElement = (id: string) => {
  const { hash } = useLocation();
  const isMounted = useMount();

  const hashWithoutQuery = hash.split("?")[0];

  useEffect(() => {
    if (!isMounted) return;
    if (hashWithoutQuery === `#${id}`) {
      let cancelled = false;
      // Wait for web fonts to finish loading (they shift layout) instead of a fixed timeout —
      // resolves immediately when fonts are already cached.
      document.fonts.ready.then(() => {
        if (cancelled) return;
        const elm = document.getElementById(id);
        if (!elm) return;
        elm.scrollIntoView({ behavior: "smooth", block: "center" });
      });
      return () => {
        cancelled = true;
      };
    }
  }, [isMounted, hashWithoutQuery]);

  return { elmId: id };
};
